import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { ContentfulImage, ContentfulImageTransformOptions, Image, theme } from '@sg/garnish';

import { BUNDLE_HERO_ASPECT_RATIO } from '../../Bundle.constants';

const BundleHeroFallbackImage = require('../../bundle-hero-fallback.webp');

// ─────────────────────────────────────────────────────────────────────────────

export const BundleHero = (props: Props) => {
  const { imageUrl, imageA11y } = props;

  const { formatMessage } = useIntl();

  if (!imageUrl) {
    return (
      <Image
        source={BundleHeroFallbackImage}
        alt={formatMessage(messages.fallbackImageA11y)}
        style={styles.hero}
      />
    );
  }

  return (
    <ContentfulImage
      alt={imageA11y ?? formatMessage(messages.fallbackImageA11y)}
      baseUrl={imageUrl}
      options={IMAGE_OPTIONS}
      style={styles.hero}
    />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_OPTIONS: Partial<ContentfulImageTransformOptions> = { fm: 'webp', w: 500 };

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  hero: {
    width: '100%',
    aspectRatio: BUNDLE_HERO_ASPECT_RATIO,
    backgroundColor: theme.colors.KALE,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  fallbackImageA11y: {
    defaultMessage: 'An assortment of sweetgreen plates',
    description: 'Bundle | Hero | Fallback image accessibility label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  imageUrl?: string;
  imageA11y?: string;
};
